var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"skeleton",class:[
    _vm.round ? 'rounded-full' : '',
    _vm.fullSize ? 'h-full w-full absolute top-0 left-0 bottom-0 right-0 block' : 'relative inline-block'
  ],style:([ !_vm.fullSize && { height: _vm.height, width: _setup.computedWidth }])})
}
var staticRenderFns = []

export { render, staticRenderFns }